import { CirclePlus } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";

import notFoundUser from "@/assets/images/NotFoundUser.svg";
import { PATHS } from "@/config/path";
import {
  BRAND_WIZARD_RETURN_TO_KEY,
  setWizardReturnTo,
} from "@/modules/wizardReturnTo";
import { commonIconProps20 } from "@/utils/constants";

import { CustomButton } from "../Button";

const NotFoundGroup = () => {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const brandWizardPath = PATHS.ADMIN.BRAND_WIZARD_DETAILS(undefined, id);

  return (
    <div className="flex justify-center items-center px-4 w-full h-[60vh] border border-gray-200">
      <div className="flex flex-col gap-2 max-w-[330px] items-center">
        <img src={notFoundUser} alt="No users found" className="w-[230px]" />
        <div className="flex flex-col items-center gap-4">
          <p className="text-center font-bold">This group has no brands yet.</p>
          <CustomButton
            type="button"
            data-testid="admin-account-invite-button"
            className="gap-[11px] px-3.5!"
            asChild
          >
            <Link
              to={brandWizardPath}
              onClick={() => {
                setWizardReturnTo(
                  BRAND_WIZARD_RETURN_TO_KEY,
                  PATHS.ADMIN.ACCOUNT_GROUP_DETAILS(id)
                );
                navigate(brandWizardPath);
              }}
            >
              <CirclePlus {...commonIconProps20} />
              <span>Add new brand</span>
            </Link>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default NotFoundGroup;
